export function episodeTrimKey(episodeId: string | undefined) {
  return ['episodeTrim', episodeId] as const;
}

export function episodeSegmentsKey(episodeId?: string) {
  return episodeId ? (['episodeSegments', episodeId] as const) : (['episodeSegments'] as const);
}

export function aiPendingSegmentsKey(episodeId: string | undefined) {
  return ['aiPendingSegments', episodeId] as const;
}

export function cloudEpisodeKey(episodeId: string) {
  return ['cloudEpisode', episodeId] as const;
}

export const DATASET_EPISODES_KEY = ['datasetEpisodes'] as const;
export const ALL_SUBTASKS_KEY = ['allSubtasks'] as const;
export const SEGMENT_LABELS_KEY = ['segmentLabels'] as const;
export const LABEL_STATS_KEY = ['labelStats'] as const;
